import {
    Component,
    Inject,
    Input,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { FileUpload, IStatusMessage, ResponseStatus } from '../../shared';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { Logo } from '../store/logo.model';

@Component({
    selector: 'ef-logo-presenter',
    templateUrl: './logo-presenter.component.html',
    styleUrls: ['./logo-presenter.component.scss'],
    standalone: false
})
export class LogoPresenterComponent implements OnInit {
    SelectedErrorSubject = new ReplaySubject<IStatusMessage>(1);
    private _selectedError: IStatusMessage;
    selectedLogo: any;
    @Input() public set selectedError(value: IStatusMessage) {
        this.SelectedErrorSubject.next(value);
        if (!value) {
            return;
        }
        if (this._selectedError && this._selectedError.MsgEntityID) {
            const oldRow = document.getElementById(
                `row-${this._selectedError.MsgEntityID.toString()}`
            );
            if (oldRow) {
                oldRow.classList.remove('highlight');
                oldRow.classList.remove('highlight-warning');
                oldRow.classList.remove('highlight-danger');
            }
        }
        this._selectedError = value;
        if (!(value && value.MsgEntityID)) {
            return;
        }
        const row = document.getElementById(
            `row-${value.MsgEntityID.toString()}`
        );
        if (!row) {
            return;
        }
        row.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest'
        });
        row.classList.add('highlight');
        if (value.StatusCode === ResponseStatus.Warning) {
            row.classList.add('highlight-warning');
        }
        if (value.StatusCode === ResponseStatus.Failed) {
            row.classList.add('highlight-danger');
        }
    }
    public get selectedError(): IStatusMessage {
        return this._selectedError;
    }

    private LogoSubject = new ReplaySubject<Logo>(1);
    private _logo: Logo;
    @Input() set logo(value: Logo) {
        if (value) {
            this._logo = value;
            this.selectedLogo =
                'data:image/png;base64,' + this._logo.Uploadfile;
            this.LogoSubject.next(value);
        }
    }
    get logo(): Logo {
        return this._logo;
    }

    uploadedFiles: any[] = [];
    showUploadComplete = false;
    uploadCompleteMsg = '';
    @Output() SaveLogo = new ReplaySubject<Logo>(1);
    @ViewChild('logoUploader', { static: true })
    logoUploader: FileUpload;

    constructor(@Inject(LoggingService) private log: LoggingService) {}

    ngOnInit() {
        this.setupObservables();
        this.setupSubscriptions();
    }

    setupObservables() {
        this.log.verbose({
            type: 'LogoPresenterComponent:setupObservables'
        });
    }

    setupSubscriptions() {
        this.log.verbose({
            type: 'LogoPresenterComponent:setupSubscriptions'
        });
    }

    onLogoSelect(event) {
        // const fileReader = new FileReader();
        // fileReader.onload = (e: any) => {
        //   this.log.verbose({
        //     type:
        //         'LogoPresenterComponent:onLogoSelect:onFileReaderLoad',
        //     e
        //   });
        //   // Will print the base64 here.
        //   const result = e.target.result as any;
        //   this.selectedLogo = result;
        // };
        // fileReader.readAsDataURL(event.files[0]);
    }

    uploadLogo(event) {
        const fileReader = new FileReader();
        fileReader.onload = (e: any) => {
            this.log.verbose({
                type: 'LogoPresenterComponent:uploadLogo:onFileReaderLoad',
                e
            });
            // Will print the base64 here.
            const result = e.target.result as any;
            this.log.verbose('result: ' + result);
            // this.selectedLogo = result;
            this.SaveLogo.next(result.substring(result.indexOf(',') + 1));
        };
        fileReader.readAsDataURL(event.files[0]);
        this.logoUploader.clear();
        this.uploadCompleteMsg = 'Upload Complete';
        this.showUploadComplete = true;
        setTimeout(() => {
            this.uploadCompleteMsg = '';
            this.showUploadComplete = false;
        }, 3000);
    }
}
